<template lang='pug'>
.question-list-container
    .row
        van-icon(name='plus')
        .new(@click='createNew') 新建会话
    TicketList(
        :projectId='projectId',
        @loaded='loaded',
        :listDic='listDic',
        v-if='staffId != null',
        ref='list'
    )
        template(v-slot='{ item }')
            template(v-if='item.parameters[0]')
                .panel
                    .title {{ getValue(item.parameters) }}
                    .bottom-row
                        .domain 提交于 {{ day(item.createdAt).format("YYYY/MM/DD HH:mm:ss") }}
                        van-button(
                            v-if='staffId && item.status.statusId === processStatuses[0]',
                            type='primary',
                            size='small',
                            :loading='claimLoading[item.id]',
                            :disabled='claimDisabled',
                            @click='claim(item)'
                        ) 认领
                        van-badge(
                            v-else,
                            :content='newLogDic[item.ticketNumber]',
                            max='99'
                        )
                            van-button(
                                type='primary',
                                size='small',
                                @click='goReply(item)'
                            ) 进入对话
</template>

<script>
import TicketList from '../components/TicketList'
import day from 'dayjs'
import { GetNewLogNumber, PutTransition, GetAvailableStatus, GetAuditList, GetSubmitList } from '@/service/ticket'
import {
    getStorage
} from '@/utils/localstorage.js'
import { Log_Status, LIST_LOG_LOOP_INTERVAL } from '@/configs/constants'
const {
    VUE_APP_TICKET_SERVICE_ID,
    VUE_APP_TICKET_QUESTION_PROCESS,
    VUE_APP_TICKET_QUESTION_END } = window.env
const [processStatuses, endStatus] = [VUE_APP_TICKET_QUESTION_PROCESS, VUE_APP_TICKET_QUESTION_END]
import createNew from './createNew'
import { mapActions } from 'vuex'
export default {
    mixins: [createNew],
    components: {
        TicketList
    },
    data() {
        return {
            projectId: VUE_APP_TICKET_SERVICE_ID,
            newLogDic: {},
            logLoopTimer: null,
            processStatuses,
            endStatus,
            claimLoading: {},
            staffId: null,
            claimDisabled: false
        }
    },
    computed: {
        listDic() {
            if (this.staffId) {
                return [
                    {
                        remark: '待认领的会话',
                        id: processStatuses[0]
                    },
                    {
                        remark: '进行中的会话',
                        id: processStatuses[1]
                    },
                    {
                        remark: '已结束会话',
                        id: endStatus.toString()
                    },
                ]
            } else {
                return [
                    {
                        remark: '进行中的会话',
                        id: processStatuses.toString()
                    },
                    {
                        remark: '已结束会话',
                        id: endStatus.toString()
                    },
                ]
            }
        }
    },
    methods: {
        ...mapActions(['getRole']),
        day,
        getValue(parameters) {
            if (this.staffId) {
                // 员工展示公司
                return parameters.find(item => item.title === '公司').value
            } else {
                // 展示询问类型
                return parameters.find(item => item.type === 'textarea')?.value
            }
        },
        async detectNewLog(data) {
            try {
                this.clearTimers()
                const logStatus = getStorage(Log_Status) || []
                let nextLogs = null
                data.forEach(item => {
                    if (!nextLogs) {
                        nextLogs = {}
                    }
                    nextLogs[item.ticketNumber] = logStatus[item.ticketNumber] || 0
                })
                if (nextLogs) {
                    const messageUnread = await GetNewLogNumber({
                        projectId: this.projectId,
                        logTypes: ['Reply'],
                        nextLogs
                    })
                    for (let [ticketNumber, unreadNumber] of Object.entries(messageUnread)) {
                        this.$set(this.newLogDic, ticketNumber, unreadNumber == 0 ? null : unreadNumber)
                    }
                }
                this.logLoopTimer = setTimeout(() => {
                    this.detectNewLog(data)
                }, LIST_LOG_LOOP_INTERVAL);
            } catch (error) {
                this.$message.fail(error.message)
            }
        },
        goReply(item) {
            this.$router.push({ name: "serviceDetail", params: { id: item.ticketNumber } })
        },
        clearTimers() {
            if (this.logLoopTimer) {
                clearTimeout(this.logLoopTimer)
                this.logLoopTimer = null
            }
        },
        loaded({ data, status }) {
            if (data.length) {
                this.detectNewLog(data)
            }
        },
        async getAvailableStatus(ticketNumber) {
            const { statuses } = await GetAvailableStatus(this.projectId, ticketNumber)
            return statuses.slice(1)
        },
        // 认领工单
        claim(item) {
            this.$confirm({
                title: '认领工单',
                message: `确定认领【${this.getValue(item.parameters)}】吗？`,
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(async () => {
                try {
                    this.$set(this.claimLoading, item.id, true)
                    const [nextStatus] = await this.getAvailableStatus(item.ticketNumber)
                    let statusId
                    if (nextStatus) {
                        statusId = nextStatus.id
                    } else {
                        throw Error('无流转状态')
                    }
                    await PutTransition({
                        projectId: this.projectId,
                        ticketNumber: item.ticketNumber,
                        statusId,
                        auditorIds: [this.staffId],
                        staffId: this.staffId,
                    })
                    this.$refs.list.loadData(true)
                    this.$message.success('认领成功')
                } catch (error) {
                    this.$message.fail(error.message)
                } finally {
                    this.claimLoading[item.id] = false
                }
            }).catch(() => { })
        },
        async setClaimStatus() {
            this.staffId = (await this.getRole(this.projectId)).staffId || ''
            if (this.staffId) {
                const { total } = await GetAuditList({ statusId: processStatuses[1], staffId: this.staffId, projectId: this.projectId, index: 1, size: 15 })
                this.claimDisabled = total >= 15
            }
        }
    },
    created() {
        this.setClaimStatus()
    },
    beforeDestroy() {
        this.clearTimers()
    }
}
</script>

<style scoped lang='less'>
@import '~@/assets/style/mixin.less';

.question-list-container {
    padding: 0 1rem;
}
.row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    i {
        margin-right: 4px;
        color: @blue;
    }
}
.new {
    color: @blue;
    margin: 0.3rem 0;
    font-size: 0.7rem;
}
.panel {
    border: 1px solid @green;
    padding: 0.8rem 0.6rem;
    margin-bottom: 1.2rem;
}
.title {
    font-size: 0.8rem;
    display: flex;
    align-items: center;
    &::before {
        content: '';
        background: @themeColor;
        width: 0.1rem;
        height: 0.8rem;
        margin-right: 0.5rem;
    }
}
.bottom-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 1rem;
    .domain {
        color: #b6b6b6;
        font-size: 0.65rem;
        > span:not(:last-child) {
            margin-right: 0.8rem;
        }
    }
}
</style>